var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.028,
    height: 25.028,
    viewBox: "0 0 25.028 25.028",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_40605",
    "data-name": "Path 40605",
    d: "M14.525,17.877l2.682-2.458a.821.821,0,0,1,.67-.223l.447.223,6.257,2.9c.447.223.447.447.447.894-.223,1.788-.67,3.128-1.788,4.022a6.4,6.4,0,0,1-4.693,1.788,13.616,13.616,0,0,1-6.257-1.564,29.294,29.294,0,0,1-6.257-4.469,38.062,38.062,0,0,1-3.352-4.916A30.888,30.888,0,0,1,.447,9.162,13.751,13.751,0,0,1,0,4.916,5.872,5.872,0,0,1,1.564,1.564C2.458.67,3.8.223,5.81,0A1.161,1.161,0,0,1,6.7.447L10.056,6.7a.78.78,0,0,0,.223.447.821.821,0,0,1-.223.67L7.151,10.5a1,1,0,0,0,0,1.117A21.339,21.339,0,0,0,9.832,15.2a22.563,22.563,0,0,0,3.575,2.9C13.855,18.324,14.3,18.324,14.525,17.877Z",
    fill: "#4b4b4b"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/Phone.9385823a9045a557a6e8c5251e6701b1.svg";
export { ForwardRef as ReactComponent };